// API Configuration
const API_CONFIG = {
  // Development: Direct requests to localhost:5000
  // Production: Use relative URLs to avoid CORS issues
  BASE_URL: process.env.NODE_ENV === 'production' 
    ? '' // Use relative URLs in production to avoid CORS
    : 'http://localhost:5000', // Development: direct requests to backend
  
  // Alternative: Use environment variable if needed
  // BASE_URL: process.env.REACT_APP_API_URL || '',
  
  // Full backend URL (only for reference)
  BACKEND_URL: 'https://portal-backend.theacademiccity.com'
};

export default API_CONFIG;
